import { Controller } from "@hotwired/stimulus";

// SAL-012: the Drafts filters submit themselves on change, so the URL
// carries the selection. The Filter button stays for keyboards and no-JS.
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
